export default {
  en: {
    /* ----- Asset Management ----- */
    // Assets.vue
    assets: "Assets",
    somethingWentWrongLoadingAssets:
      "Something went wrong while loading the assets. Please try after some time.",

    // ListAssets.vue
    macAddress: "MAC Address",
    serialNumber: "Serial Number",
    serialNumberUpdatedSuccessfully: "Serial number updated successfully.",
    computerName: "Computer Name",
    operatingSystem: "Operating System",
    appVersion: "App Version",
    assetOwner: "Asset Owner",
    systemUserName: "System User Name",
    status: "Status",
    noMatchingSearchResults: "No matching search results found.",
    tryAgainByChangingFilters:
      "Please try again by changing the filters or clear it to get all data.",
    clearAll: "Clear All",
    accessDeniedUpdateAssetStatus:
      "Sorry, you don't have access to update asset status. Please contact system administrator.",
    assetStatusUpdatedSuccessfully: "Asset status updated successfully.",
    assetDeletedSuccessfully: "Asset(s) deleted successfully.",
    selectAll: "Select All",
    delete: "Delete",
    forDeleteSelectAtLeastOneRecord:
      "For Delete, you have to select atleast one record.",
    noAccessToDeleteAsset: "Sorry, you don't have access to delete the asset.",
    technicalDifficultiesWhileFetchingAssets:
      "It's us! There seems to be some technical difficulties while fetching the assets. Please try after some time.",
    somethingWentWrongFetchingAssets:
      "Something went wrong while fetching the assets. If you continue to see this issue, please contact the platform administrator.",
    technicalDifficultiesWhileDeletingAsset:
      "It's us! There seems to be some technical difficulties while deleting the asset. Please try after some time.",
    noAccessToDeleteAssetContactHR:
      "Sorry, you don't have access to delete the asset. Please contact HR administrator.",
    unableToDeleteAsset:
      "Unable to delete the asset as it is deleted in the same or some other user session.",
    somethingWentWrongDeletingAsset:
      "Something went wrong while deleting the asset. If you continue to see this issue, please contact the platform administrator.",
    technicalDifficultiesWhileUpdatingAssetStatus:
      "It's us! There seems to be some technical difficulties while updating the asset status. Please try after some time.",
    somethingWentWrongUpdatingAssetStatus:
      "Something went wrong while updating the asset status. If you continue to see this issue, please contact the platform administrator.",
    desktopClientDownloadNotAvailable:
      "Desktop client download is not available. Please contact the platform administrator",
    areYouSureToDeleteAsset: "Are you sure to delete the asset?",
    areYouSureToPurgeAsset: "Are you sure to purge the asset?",
    assetMappedToActiveUser:
      "Asset is mapped to an active user, Purging the asset will unmap the asset automatically and the tracking will stop for this user.",
    cancel: "cancel",
    proceed: "Proceed",
    outOf: "out of",
    defunct: "Defunct",
    working: "Working",
    cannotChangeAssetStatus:
      "The asset's status cannot be changed while it is in use, return the asset to the warehouse and initiate the change.",
    retry: "Retry",
    refresh: "refresh",
    pleaseOnboardTeam: "Please onboard your team to manage their productivity",
    noAssetsMapped: "There are no assets mapped to your organization yet",
    autoUpdate: "Auto Update",
    autoUpdateTime: "Auto Update Time",
    autoUpdateStatus: "Auto Update Status",
    autoUpdateSettingsUpdatedSuccessfully:
      "Auto update settings updated successfully.",
    enableAutoUpdate: "Enable Auto Update",
    disableAutoUpdate: "Disable Auto Update",
    autoUpdateOnlyForWindowsAssets:
      "Auto update can only be enabled for Windows assets. Please unselect other assets to proceed.",
  },
  sp: {
    /* ----- Asset Management ----- */
    // Assets.vue
    assets: "Activos",
    somethingWentWrongLoadingAssets:
      "Algo salió mal al cargar los activos. Por favor, inténtelo después de un tiempo.",

    // ListAssets.vue
    macAddress: "Dirección MAC",
    serialNumber: "Número de Serie",
    serialNumberUpdatedSuccessfully: "Número de serie actualizado con éxito.",
    computerName: "Nombre del Ordenador",
    operatingSystem: "Sistema Operativo",
    appVersion: "Versión de la Aplicación",
    assetOwner: "Propietario del Activo",
    systemUserName: "Nombre de Usuario del Sistema",
    status: "Estado",
    noMatchingSearchResults:
      "No se encontraron resultados de búsqueda coincidentes.",
    tryAgainByChangingFilters:
      "Inténtelo de nuevo cambiando los filtros o bórrelos para obtener todos los datos.",
    clearAll: "Borrar Todo",
    accessDeniedUpdateAssetStatus:
      "Lo sentimos, no tiene acceso para actualizar el estado del activo. Póngase en contacto con el administrador del sistema.",
    assetStatusUpdatedSuccessfully: "Estado del activo actualizado con éxito.",
    assetDeletedSuccessfully: "Activo(s) eliminado(s) con éxito.",
    selectAll: "Seleccionar Todo",
    delete: "Eliminar",
    forDeleteSelectAtLeastOneRecord:
      "Para eliminar, debe seleccionar al menos un registro.",
    noAccessToDeleteAsset:
      "Lo sentimos, no tiene acceso para eliminar el activo.",
    technicalDifficultiesWhileFetchingAssets:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener los activos. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongFetchingAssets:
      "Algo salió mal al obtener los activos. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",
    technicalDifficultiesWhileDeletingAsset:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al eliminar el activo. Por favor, inténtelo después de un tiempo.",
    noAccessToDeleteAssetContactHR:
      "Lo sentimos, no tiene acceso para eliminar el activo. Póngase en contacto con el administrador de RRHH.",
    unableToDeleteAsset:
      "No se puede eliminar el activo ya que se ha eliminado en la misma sesión u otra sesión de usuario.",
    somethingWentWrongDeletingAsset:
      "Algo salió mal al eliminar el activo. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",
    technicalDifficultiesWhileUpdatingAssetStatus:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al actualizar el estado del activo. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongUpdatingAssetStatus:
      "Algo salió mal al actualizar el estado del activo. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",
    desktopClientDownloadNotAvailable:
      "La descarga del cliente de escritorio no está disponible. Póngase en contacto con el administrador de la plataforma",
    areYouSureToDeleteAsset: "¿Está seguro de eliminar el activo?",
    areYouSureToPurgeAsset: "¿Está seguro de purgar el activo?",
    assetMappedToActiveUser:
      "El activo está asignado a un usuario activo. Purgar el activo lo desasignará automáticamente y el seguimiento se detendrá para este usuario.",
    cancel: "cancelar",
    proceed: "Proceder",
    outOf: "de",
    defunct: "Defectuoso",
    working: "Funcionando",
    cannotChangeAssetStatus:
      "No se puede cambiar el estado del activo mientras está en uso, devuelva el activo al almacén e inicie el cambio",
    retry: "Reintentar",
    refresh: "actualizar",
    pleaseOnboardTeam:
      "Por favor, incorpore a su equipo para gestionar su productividad",
    noAssetsMapped: "No hay activos asignados a su organización todavía",
    autoUpdate: "Actualización Automática",
    autoUpdateTime: "Hora de Actualización Automática",
    autoUpdateStatus: "Estado de Actualización Automática",
    autoUpdateSettingsUpdatedSuccessfully:
      "Configuración de actualización automática actualizada con éxito.",
    enableAutoUpdate: "Habilitar Actualización Automática",
    disableAutoUpdate: "Deshabilitar Actualización Automática",
    autoUpdateOnlyForWindowsAssets:
      "La actualización automática solo se puede habilitar para activos de Windows. Deseleccione otros activos para continuar.",
  },
};
